import * as api from '@/api'
import * as cookie from '@/api/cookie'

const scheduledRecommend = {
  namespaced: true,
  state: {
    list: [],
    firstOrderTime: null,
    lastOrderTime: null,
  },
  getters: {
    getRecommends: (state) => {
      return state.list
    },
    hasRecommends: (_state_, getters) => {
      const recommends = getters.getRecommends
      return !!recommends.length
    },
    getExistRecommends: (state, _getters_, _rootState_, rootGetters) => {
      const menus = rootGetters['menu/getMenu']
      const itemExists = rootGetters['menu/getItemExists']
      const recommends = state.list
      if (menus.length === 0) return []
      return recommends
        .map((recommend) => ({
          ...recommend,
          itemList: recommend.itemList.filter(itemExists),
        }))
        .filter((recommend) => recommend.itemList.length)
    },
    getExistRecommendsById: (_state_, getters) => (id) => {
      const recommends = getters.getExistRecommends
      return recommends.find((recommend) => recommend.id === id)
    },
    getFirstOrderTime: (state) => {
      return state.firstOrderTime
    },
    getLastOrderTime: (state) => {
      return state.lastOrderTime
    },
    getUndoneRecommends: (_state_, getters) => {
      const recommends = getters.getExistRecommends
      return recommends.filter((recommend) => !recommend.done)
    },
    getUndoneImmediateRecommends: (_state_, getters) => {
      const undoneRecommends = getters.getUndoneRecommends
      return undoneRecommends.filter((recommend) => recommend.timing === 2)
    },
    getPreparedRecommends: (_state_, getters) => () => {
      const undoneRecommends = getters.getUndoneRecommends
      const undoneImmediateRecommends = getters.getUndoneImmediateRecommends
      const firstOrderTime = getters.getFirstOrderTime
      const lastOrderTime = getters.getLastOrderTime

      let response = []
      // 未完了のレコメンドがなければ中断
      if (!undoneRecommends.length) return response
      // 認証直後レコメンドが完了していなければそれを返す
      if (undoneImmediateRecommends.length) {
        return undoneImmediateRecommends
      }
      // 未注文の場合は中断
      if (!firstOrderTime) return response

      undoneRecommends.forEach((recommend) => {
        const isFromFirstOrder = recommend.timing === 0
        const isFromLastOrder = recommend.timing === 1
        const orderTime = isFromFirstOrder ? firstOrderTime : isFromLastOrder ? lastOrderTime : null
        if (!orderTime) return

        const minutesFromOrderTime = (new Date().getTime() - orderTime) / 1000 / 60
        if (recommend.elapsed < minutesFromOrderTime) {
          response.push(recommend)
        }
      })

      return response
    },
  },
  actions: {
    async fetchRecommend({ commit }, shopId) {
      try {
        const { data } = await api.fetchRecommend(shopId)
        const doneRecommendIds = cookie.readRecommends()
        const recommendsWithDoneFlag = data.list.map((item) => ({
          ...item,
          done: !!doneRecommendIds.filter((id) => id === item.id.toString()).length,
        }))
        commit('setList', { list: recommendsWithDoneFlag })
      } catch (error) {
        return
      }
    },
    setFirstOrderTime: ({ commit }, payload) => {
      commit('setFirstOrderTime', payload)
    },
    setLastOrderTime: ({ commit }, payload) => {
      commit('setLastOrderTime', payload)
    },
    setRecommendDone: ({ commit }, payload) => {
      cookie.mergeRecommends(payload)
      commit('setRecommendDone', payload)
    },
  },
  mutations: {
    setList(state, payload) {
      state.list = payload.list
    },
    setFirstOrderTime(state, firstOrderTime) {
      state.firstOrderTime = firstOrderTime
    },
    setLastOrderTime(state, lastOrderTime) {
      state.lastOrderTime = lastOrderTime
    },
    setRecommendDone(state, id) {
      const recommends = state.list
      const recommend = recommends.find((recommend) => recommend.id === id)
      recommend.done = true
    },
  },
}

export default scheduledRecommend
